import { createContext, useContext, type ReactNode } from 'react';

interface PreviewModeContextValue {
  isPreview: boolean;
}

const PreviewModeContext = createContext<PreviewModeContextValue | null>(null);

export function PreviewModeProvider({
  children,
  isPreview = false,
}: {
  children: ReactNode;
  isPreview?: boolean;
}) {
  return (
    <PreviewModeContext.Provider value={{ isPreview }}>
      {children}
    </PreviewModeContext.Provider>
  );
}

export function usePreviewMode(): boolean {
  const ctx = useContext(PreviewModeContext);
  return ctx?.isPreview ?? false;
}
